// extracted by mini-css-extract-plugin
export default {"businessLogo":"NavBarBusinessLogo_businessLogo__poRND"};